
import React, { useState } from "react";
import { RowsPhotoAlbum } from "react-photo-album";
import "react-photo-album/rows.css";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

const photoData = [
  { src: "/Home/images/art/Azshara.webp", width: 2304, height: 3513 },
  { src: "/Home/images/art/Dance.webp", width: 2409, height: 3246 },
  { src: "/Home/images/art/dark_lady.webp", width: 850, height: 1134 },
  { src: "/Home/images/art/face.webp", width: 2290, height: 3430 },
  { src: "/Home/images/art/Geschenk an Sonja.webp", width: 543, height: 764 },
  { src: "/Home/images/art/Maryl.webp", width: 3218, height: 2432 },
  { src: "/Home/images/art/nouveau.webp", width: 2106, height: 2658 },
  { src: "/Home/images/art/woman_red.webp", width: 2659, height: 3822 },
  { src: "/Home/images/art/pearl_girl.webp", width: 1134, height: 1701 },
  { src: "/Home/images/art/pink_lady.webp", width: 1134, height: 1701 },
  { src: "/Home/images/art/Woman.webp", width: 1743, height: 2629 },
  { src: "/Home/images/art/zelda_comp2.webp", width: 2215, height: 1280 },
  { src: "/Home/images/art/ballerina.webp", width: 2805, height: 3543 },
  { src: "/Home/images/art/Graben.webp", width: 3602, height: 2758 },
  { src: "/Home/images/art/japanese_room.webp", width: 2487, height: 3795 },
  { src: "/Home/images/art/woman_black.webp", width: 2754, height: 2600 },
  { src: "/Home/images/art/woman_pencil.webp", width: 2556, height: 3817 },
  { src: "/Home/images/art/woman_pencil2.webp", width: 2366, height: 2449 },
  { src: "/Home/images/art/palette.webp", width: 1024, height: 768 },
];

export default function GalleryArea() {
  const [lightboxIndex, setLightboxIndex] = useState(-1);

  return (
    <>
      <RowsPhotoAlbum
        photos={photoData}
        layout="rows"
        padding={10}
        spacing={0}
        onClick={({ index }) => setLightboxIndex(index)}
      />
      <Lightbox
        open={lightboxIndex >= 0}
        index={lightboxIndex}
        close={() => setLightboxIndex(-1)}
        slides={photoData.map(({ src }) => ({ src }))}
      />
    </>
  );
}
